import React from 'react';
import { ReceiptIllustrated } from '@jbhi-fi/lanyard-ui/components/Icons';
import { Tick } from '@jbhi-fi/lanyard-ui/components/Icons';
import DownloadComponent from '../components/download.component';

const PreviewComponent = ({ isPerksDisabled, storeName, dateTime, receiptId, receiptToken, history, setError }) => {
  return isPerksDisabled ? (
    <div className="receipts-preview-container">
      <DownloadComponent
        receiptId={receiptId}
        receiptToken={receiptToken}
        history={history}
        setError={setError}
        isPerksDisabled={isPerksDisabled}
      />
      <div className="receipt-logo-container">
        <ReceiptIllustrated className="receipt-logo" />
        <Tick className="receiptChecked-logo" />
      </div>
      <div className="receipt-text-container">
        <h5 className="receipt-text">Purchase from </h5>
        <h5 className="receipt-text">{storeName}</h5>
        <time className="receipt-time">{dateTime}</time>
      </div>
    </div>
  ) : (
    <div className="receipts-preview">
      <h5>Purchase from {storeName}</h5>
      <time>{dateTime}</time>
    </div>
  );
};

export default PreviewComponent;
